export const getUrlParams = (param: string): string | null => {
  const queryString = window && window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const urlParamValue: string | null = urlParams.get(param);

  return urlParamValue;
};
